module.exports = __webpack_public_path__ + "arrow.svg?fe00888419e773f1da1ceac80953c1a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.svg
// module id = 243
// module chunks = 0